export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-axis/src/array.js
// module id = ../../../../d3-axis/src/array.js
// module chunks = 3